import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Table } from 'reactstrap';
import DropDown from 'shared/components/DropDown/org_user.js';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';



 class SchedulingModel extends Component {

  
  render() {
    
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={this.props.className}>
        <ModalHeader toggle={this.props.toggle}>User assignment</ModalHeader>
        <ModalBody>
          
          <Form>
                  <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label>Start Date</Label>
                  {/* <Input type={"date"} name={"start_date"}  min={this.props.min} onChange={this.props.schdStartDate} value={this.props.start_date} placeholder={""} /> */}
                  
                  <DatePicker selected={moment(this.props.start_date)}  name={"start_date"} withPortal fixedHeight onChange={this.props.scheChange} className="form-control"  minDate={moment(this.props.min)} maxDate={this.props.maxDate}  dateFormat="DD-MM-YYYY"/>
                  <span className="error-text">{this.props.validator.message('start_date', this.props.start_date, 'required',false,{default: 'This field is required.'})}</span>
                </FormGroup>
              </div>
              
            </div>

            <div className="row">
            <div className="col-md-12">
            <FormGroup>
            <Label>User Allocation</Label>
            <Select name="selected_value" value={this.props.selected_value} onChange={this.props.handleSelectChange} multi options={this.props.orgUserList}/>
            <span className="error-text">{this.props.validator.message('selected_value', this.props.selected_value, 'required',false,{default: 'This field is required.'})}</span>
            </FormGroup>
            </div>
            <div className="col-md-6">
            </div>
            </div>
            </Form>
            <br/>
            <br/>
        
        </ModalBody>
        <ModalFooter>
          <br/>
          <br/>
          {this.props.showRevertButton && (
            <Button color={"danger"} size={"md"} onClick={this.props.onRevertClick}>Delete</Button>
          )}{' '}
          <ActionButton color={"primary"} size={"md"} button_name={"Save & Close"} button_click={this.props.onScheduleSubmitClick}/>{' '}
          <Button color={"danger"} size={"md"} onClick={this.props.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}



SchedulingModel.defaultProps = {orgUserList: []};

export default SchedulingModel;



// WEBPACK FOOTER //
// ./src/shared/components/Models/scheduling_model.js